import { useMemo } from 'react';
import { Text } from '@mercator-gcp/grout';
import { CompanyChip } from 'components/elements/Chips/CompanyChip';
import { EmptyField } from 'components/elements/EmptyField';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { ProjectActivity } from 'types';
import { combineCompaniesAndRelatedCompanies } from 'utils/companiesInvolved';

const cellStyle = { rowGap: 'padding_4', maxWidth: '220px' };

const MAX_COMPANIES_TO_SHOW = 3;

type Props = {
  companyList: ProjectActivity['companies'];
  relatedContacts: ProjectActivity['related_contacts'];
};

const RelatedCompaniesCell = ({ companyList, relatedContacts }: Props) => {
  const allContactsAndCompanies = useMemo(
    () => combineCompaniesAndRelatedCompanies(relatedContacts || [], companyList || []),
    [companyList, relatedContacts],
  );

  const numOverflowCompanies = useMemo(() => {
    if (!allContactsAndCompanies) {
      return 0;
    }

    return allContactsAndCompanies.length - MAX_COMPANIES_TO_SHOW;
  }, [allContactsAndCompanies?.length, MAX_COMPANIES_TO_SHOW]);

  if (!allContactsAndCompanies || allContactsAndCompanies?.length === 0) {
    return <EmptyField />;
  }

  return (
    <FlexColumn sx={cellStyle}>
      {allContactsAndCompanies.slice(0, MAX_COMPANIES_TO_SHOW)?.map((company) => (
        <CompanyChip name={company.name} id={company.uuid} />
      ))}
      {numOverflowCompanies > 0 && (
        <Text.Small>{`+${numOverflowCompanies} more`}</Text.Small>
      )}
    </FlexColumn>
  );
};

export default RelatedCompaniesCell;
